

import { Component, Vue, Watch, Prop, Emit } from "vue-property-decorator"
import { namespace, Getter, Action, Mutation } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { BModal } from "bootstrap-vue"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar
	}
})
export default class Confirmation extends Vue {
	$refs!: {
		confirmModal: BModal
	}

	@Prop()
	title!: string;

	@Prop({ type: Boolean, default: true })
	isDelete!: boolean;

	@Prop({ type: String, default: "l" })
	public modalSize!: string;

	confirmTitle: string = "";
	confirmFunction: (() => void) | null = null;

	public open (itemTitle: string, confirm: () => void) {
		this.confirmTitle = itemTitle
		this.confirmFunction = confirm

		this.$refs.confirmModal.show()
	}

	public confirm () {
		if (this.confirmFunction) {
			this.confirmFunction()
		}
		this.$refs.confirmModal.hide()

		this.confirmFunction = null
		this.confirmTitle = ""
	}
}

